import loadderSlice from './loadderSlice';
import errorSlice from './errorSlice';
import tokenSlice from './tokenSlice';
import propsDataSlice from './propsDataSlice';
import configSlice from './configSlice';

export default {
  error: errorSlice,
  loadder: loadderSlice,
  tokens: tokenSlice,
  propsData: propsDataSlice,
  config: configSlice,
};
